module.exports = __webpack_public_path__ + "media/customizations/newfield/logo-d5e4a14efb4315fb55f8a0840b987024.png";